<template>
    <v-card>
        <v-card-title>
            Contact Information
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="cn" readonly hide-details label="Name">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="username" readonly hide-details label="Western Email" suffix="@uwo.ca">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="address" readonly hide-details label="Current Address">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-title>
            Authorized Individual(s)
        </v-card-title>
        <v-card-text v-for="(user, i) in contacts" :key="i">
            <v-card-title class="pb-0">
                Authorized Individual {{ i + 1 }}
                - {{ user.name }}
            </v-card-title>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" lg="4">
                        <v-text-field v-model="user.name" readonly hide-details label="Authorized Individual's Name">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-select v-model="user.relationship" readonly hide-details :items="relationshipItems"
                            label="Relationship">
                        </v-select>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-text-field v-model="user.relationshipDetail" readonly hide-details
                            label="Relationship (Other)" placeholder="None">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field v-model="user.phone" readonly hide-details label="Telephone Number">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field v-model="user.mail" readonly hide-details label="Email Address">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field v-model="user.startDate" readonly hide-details label="Authorization Start Date"
                            prepend-icon="mdi-calendar-check">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field v-model="user.endDate" readonly hide-details label="Authorization End Date"
                            prepend-icon="mdi-calendar-remove">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card-subtitle class="font-weight-bold pb-0 px-0">Authorized Method of Access
                        </v-card-subtitle>
                        <div>Please indicate how you authorize this person to access the
                            specific information (Check all that
                            apply).</div>
                        <v-checkbox v-model="user.accessMethod" readonly hide-details label="By Phone" value="phone">
                        </v-checkbox>
                        <v-checkbox v-model="user.accessMethod" readonly hide-details label="In Person"
                            value="inperson">
                        </v-checkbox>
                        <v-checkbox v-model="user.accessMethod" readonly hide-details label="Email" value="email">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="user.accessCode" readonly hide-details
                            label="Authorized Individual's Code Word">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-card-subtitle class="font-weight-bold pb-0 px-0">Access Residence Information
                        </v-card-subtitle>
                        <div>Please indicate what your authorized person has access to (Check all that
                            apply).</div>
                        <v-checkbox v-model="user.accessResidenceInformation" readonly hide-details
                            label="Room Location" value="room location">
                        </v-checkbox>
                        <v-checkbox v-model="user.accessResidenceInformation" readonly hide-details
                            label="Mailbox Number" value="mailbox number">
                        </v-checkbox>
                        <v-checkbox v-model="user.accessResidenceInformation" readonly hide-details
                            label="Residence Financial Account" value="residence financial account">
                        </v-checkbox>
                        <v-checkbox v-model="user.accessResidenceInformation" readonly hide-details
                            label="Resident Conduct File" value="residence conduct file">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <v-card-subtitle class="font-weight-bold pb-0 px-0">Emergency Contact</v-card-subtitle>
                        <div>Please indicate if this authorized person may be contacted on your behalf
                            in the event of an emergency.</div>
                        <v-radio-group v-model="user.emergencyContact" dense hide-details readonly>
                            <v-radio label="Yes" value="1"></v-radio>
                            <v-radio label="No" value="0"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
        </v-card-text>
        <v-card-actions v-if="!admin">
            <v-spacer>
            </v-spacer>
            <v-btn :color="successColor" dark :loading="submitBool" @click="openDialog()">
                Submit
            </v-btn>
            <v-btn :color="kingsGrey" dark @click="setStep(2)">
                Previous
            </v-btn>
        </v-card-actions>
        <v-dialog v-if="!admin" v-model="dialog" max-width="540">
            <v-card>
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Please ensure that the information provided is accurate and reliable. If you wish to submit the
                    release of information form, please click confirm.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="successColor" text @click="submitForm()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
export default {
    name: 'release-of-information-review',
    props: {
        address: {
            required: true
        },
        admin: {
            type: Boolean
        },
        cn: {
            required: true
        },
        contacts: {
            required: true,
            type: Array
        },
        submitBool: {
            required: true,
            type: Boolean
        },
        username: {
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            relationshipItems: [{
                    text: 'Parent',
                    value: 'parent'
                },
                {
                    text: 'Guardian',
                    value: 'guardian'
                },
                {
                    text: 'Sibling',
                    value: 'sibling'
                },
                {
                    text: 'Friend',
                    value: 'friend'
                },
                {
                    text: 'Other',
                    value: 'other'
                }
            ]
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        openDialog() {
            this.dialog = true;
        },
        setStep(val) {
            this.$emit('setStep', val);
            this.$nextTick(() => {
                this.$emit('scrollToTop');
            })
        },
        submitForm() {
            // Submit form
            this.$emit('submitForm');
            this.closeDialog();
        }
    },
    computed: {
        successColor() {
            return '#1bc5bd';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        warningColor() {
            return '#ffa800'
        }
    }
}
</script>

<style scoped>
.v-input--checkbox {
    margin-top: 0;
}
</style>